// in addUploadFeature.js
/**
 * Convert a `File` object returned by the upload input into a base 64 string.
 * That's not the most optimized way to store images in production, but it's
 * enough to illustrate the idea of data provider decoration.
 */
const convertFileToBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file.rawFile);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
});
 
/**
 * For posts update only, convert uploaded image in base 64 and attach it to
 * the `picture` sent property, with `src` and `title` attributes.
 */
const addUploadFeature = requestHandler => (type, resource, params) => {
    
    console.log( type, resource, params  );


    if ((type === 'UPDATE' || type === 'CREATE') && (resource === 'documents' || resource === 'files' )) {
        // notice that following condition can be true only when `<ImageInput source="pictures" />` component has parameter `multiple={true}`
        // if parameter `multiple` is false, then data.pictures is not an array, but single object
        //if (params.data.file && params.data.file.length) {
        if (params.data.document ) {    
            /*if ( params.data.document.length  ){
                const newFile = params.data.document.filter(p => p.rawFile instanceof File);
            }
            else
            {*/
                const newFile = [params.data.document];
            //}

            // only freshly dropped pictures are instance of File
           // const formerFile = params.data.file.filter(p => !(p.rawFile instanceof File));
                
            return Promise.all(newFile.map(convertFileToBase64))
                .then(base64File => base64File.map((file64, index) => ({
                    src: file64,
                    title: `${newFile[index].title}`,
                })))
                .then(transformedNewFile => requestHandler(type, resource, {
                    ...params,
                    data: {
                        ...params.data,
                        document: [...transformedNewFile]
                    },
                }));
        }
    }
    if (( type === 'UPDATE' || type === 'CREATE') && resource === 'clients' ) {
        if (params.data.logo ) {    
            const newFile = [params.data.logo];
                
            return Promise.all(newFile.map(convertFileToBase64))
                .then(base64File => base64File.map((file64, index) => ({
                    src: file64,
                    title: `${newFile[index].title}`,
                })))
                .then(transformedNewFile => requestHandler(type, resource, {
                    ...params,
                    data: {
                        ...params.data,
                        logo: [...transformedNewFile]
                    },
                }));
        }
    }

    if (( type === 'UPDATE') && resource === 'avatars' ) {
        if (params.data.photo ) {    
            const newFile = [params.data.photo];
                
            return Promise.all(newFile.map(convertFileToBase64))
                .then(base64File => base64File.map((file64, index) => ({
                    src: file64,
                    title: `${newFile[index].title}`,
                })))
                .then(transformedNewFile => requestHandler(type, resource, {
                    ...params,
                    data: {
                        ...params.data,
                        photo: [...transformedNewFile]
                    },
                }));
        }
    }
    // for other request types and resources, fall back to the default request handler
    return requestHandler(type, resource, params);
};

export default addUploadFeature;